<template>
  <div>
    <!-- <component :is="'script'" src="SIPml-api.js" async></component> -->

    <v-app-bar :color="isDark ? '#121212' : '#eff0f8'" app flat>
      <v-btn v-if="userData.role_id !== 9" icon @click="drawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <v-toolbar-title v-if="!isMobile" :class="isDark ? 'blue-grey--text text--lighten-4' : 'blue-grey--text'">{{
        PageTitle || title
      }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- Agent extension Status  -->
      <v-card flat class="py-1 px-1 mr-1" color="#ffffffcc" v-if="userData.role_id == 3 && hasRTC && AutoAnswerCalls">
        <v-row dense justify="center" align="center">
          <v-col cols="auto" class="mr-0">
            <status-menu></status-menu>
          </v-col>
        </v-row>
      </v-card>

      <v-card flat class="py-1 px-1 mr-1" color="#ffffffcc" v-if="userData.role_id == 3 && !toolbarIcons && hasRTC">
        <v-row dense justify="center" align="center">
          <v-col cols="auto" class="mr-0">
            <v-btn
              small
              icon
              :color="isConnectedToSIP == true ? 'success' : ''"
              class="mx-1"
              @change="toggleIsConnectedToSip"
            >
              <!-- <v-icon>{{
                plantConnect == true ? "mdi-phone-check" : "mdi-phone-remove"
              }}</v-icon> -->
              <v-icon> mdi-phone-check </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card flat class="py-1 px-1 mr-1" color="#ffffffcc" v-if="userData.role_id == 3 && !isMobile && hasRTC">
        <v-row dense justify="center" align="center">
          <v-col cols="auto" class="mr-0">
            <v-btn
              small
              icon
              :color="isConnectedToSIP == true ? 'success' : ''"
              class="mx-1"
              @change="toggleIsConnectedToSip"
            >
              <!-- <v-icon>{{
                isConnectedToSIP == true
                  ? "mdi-phone-check"
                  : "mdi-phone-remove"
              }}</v-icon> -->
              <v-icon> mdi-phone-check </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card flat color="transparent" class="py-1 px-1" v-if="userData.role_id == 3 && !isMobile">
        <v-row dense justify="end" align="center">
          <v-col cols="auto" class="ml-0">
            <!-- <v-menu
              close-on-click
              right
              :max-width="250"
              :nudge-width="100"
              transition="slide-x-transition"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  small
                  class="pa-2 pr-0 body-2 text-right"
                  style="cursor: pointer"
                >
                  {{ connectValue == 0 ? "Desconectado" : "Conectado" }}
                </div>
              </template>

              <v-card>
                <v-list dense>
                  <v-list-item
                    v-for="(client, index) in messageQueue"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ client.queue }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        client.codigo | queueEstatus()
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu> -->
          </v-col>

          <v-col cols="auto" class="mr-0">
            <v-btn
              fab
              depressed
              outlined
              small
              class="mr-1"
              :color="connectValue == 1 ? 'success' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
              @change="verifyExtension"
            >
              <v-icon>mdi-power</v-icon>
            </v-btn>

            <!-- EDITAR AQUI -->
          </v-col>
        </v-row>
      </v-card>

      <v-card flat class="py-1" color="#ffffffcc" v-if="userData.role_id == 3 && !toolbarIcons">
        <v-row dense justify="end" align="center">
          <!-- <v-col cols="auto" class="ml-0">
            <v-menu
              close-on-click
              right
              :max-width="250"
              :nudge-width="100"
              transition="slide-x-transition"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  small
                  class="pa-2 body-2"
                  style="cursor: pointer"
                >
                  {{ connectValue == 0 ? "Desconectado" : "Conectado" }}
                </div>
              </template>

              <v-card>
                <v-list dense>
                  <v-list-item
                    v-for="(client, index) in messageQueue"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ client.queue }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        client.codigo | queueEstatus()
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col> -->

          <v-col cols="auto">
            <!-- <v-switch
              small
              inset
              v-model="plantConnect"
              @change="verifyExtension"
              color="success"
              hide-details
            ></v-switch> -->

            <v-btn small icon :color="connectValue == 1 ? 'success' : ''" class="mx-1" @change="verifyExtension">
              <v-icon>mdi-power</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <div v-show="toolbarIcons">
        <!-- <v-card flat class="py-2" color="#ffffffcc"> -->
        <!-- Messages -->
        <v-menu
          :close-on-content-click="false"
          :max-width="350"
          :nudge-width="200"
          transition="slide-x-transition"
          v-if="userData.role_id == 3 || userData.role_id == 2"
        >
          <template v-slot:activator="{ on }">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                icon
                small
                class="mx-2"
                :color="hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
                v-on="on"
              >
                <v-badge
                  :content="MessagesUnreadCounter"
                  :value="MessagesUnreadCounter"
                  offset-x="15"
                  offset-y="15"
                  color="green"
                  overlap
                >
                  <v-icon
                    class="mx-2"
                    :color="hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
                    v-on="on"
                  >
                    mdi-message-badge-outline mdi-bell
                  </v-icon>
                </v-badge>
              </v-btn>
            </v-hover>
          </template>

          <v-card width="400">
            <v-list class="py-0">
              <v-list-item>
                <v-list-item-title class="font-weight-medium">
                  Mensajes
                </v-list-item-title>
              </v-list-item>
            </v-list>

            <div style="max-height: 400px">
              <v-list>
                <v-data-iterator
                  :items="messageList"
                  no-data-text="No hay mensajes disponibles"
                  class="px-2"
                  :items-per-page="15"
                  hide-default-footer
                >
                  <template v-slot:default="props">
                    <v-list-item
                      v-for="(item, index) in props.items"
                      :key="index"
                      :class="item.for[0].view === 0 ? 'amber lighten-4' : ''"
                      @click="viewMessage(item.id)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-avatar v-if="item.for[0].view === 0" color="red darken-1" size="10">
                      </v-list-item-avatar>
                    </v-list-item>
                  </template>
                </v-data-iterator>
              </v-list>
            </div>
            <v-card-actions>
              <v-pagination v-model="messagePage" :length="messageTotalPages" circle></v-pagination>
            </v-card-actions>
          </v-card>
        </v-menu>

        <!-- Agent Call -->
        <template v-if="showAgentCall">
          <v-tooltip bottom color="blue-grey" :disabled="!ProfileInfo.active_pending_typing && !notify.typing_count">
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <div v-on="on" class="d-inline-block">
                  <v-btn
                    :disabled="
                      ProfileInfo.active_pending_typing === 1 ? (notify.typing_count > 0 ? true : false) : false
                    "
                    icon
                    small
                    class="mx-1"
                    :color="hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
                    @click="openDialerDialog"
                  >
                    <v-icon> mdi-phone </v-icon>
                  </v-btn>
                </div>
              </v-hover>
            </template>
            <span>Debe tipificar para llamar</span>
          </v-tooltip>
        </template>

        <break-menu></break-menu>

        <!-- Calendario -->
        <!-- <v-hover v-slot:default="{ hover }">
          <v-btn
            icon
            small
            class="mx-2"
            :color="
              hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'
            "
            @click="isOpenEventForm = true"
          >
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </v-hover> -->

        <!-- Send SMS -->
        <template v-if="[1, 2, 3].includes(userData.role_id)">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  icon
                  v-on="on"
                  small
                  class="mx-2"
                  @click="OPENSMSDIALOG"
                  :color="hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'"
                >
                  <v-icon>mdi-message-plus</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Enviar SMS</span>
          </v-tooltip>
        </template>
        <!-- </v-card> -->
      </div>

      <v-btn v-if="isMobile" icon @click="toolbarIcons = !toolbarIcons">
        <v-icon v-if="toolbarIcons">mdi-close-circle</v-icon>
        <v-icon v-else>mdi-dots-horizontal-circle</v-icon>
      </v-btn>

      <user-menu></user-menu>
    </v-app-bar>

    <message-preview-dialog
      v-if="isOpenMessagesDialog"
      :isOpen="isOpenMessagesDialog"
      :messageId="messageSelectedId"
      @dialog:close="closeMessageDialog"
    ></message-preview-dialog>

    <sms-send v-if="smsDialog" :isActive="smsDialog" @close:dialog="CLOSESMSDIALOG"></sms-send>
    <agent-dialer-dialog @finished:call="getTypification"></agent-dialer-dialog>

    <typification-form
      v-if="isOpenTypification"
      :dialog="isOpenTypification"
      @close:dialog="isOpenTypification = false"
      :temporaryTableId="typificationData.temporaryTableId"
      :queueNumber="typificationData.queueNumberSelected"
    />

    <new-scheduled-task
      v-if="isOpenEventForm"
      :isActive="isOpenEventForm"
      @close:dialog="closeFormDialog"
    ></new-scheduled-task>
  </div>
</template>

<script>
// import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { mapState, mapActions } from "vuex";
import moment from "moment";

import SmsSend from "@/components/SmsSend";
import AgentDialerDialog from "../Agents/DialerDialog/index.vue";
import TypificationForm from "@/views/app/agents/Typification/TypificationForm.vue";
import newScheduledTask from "@/views/app/scheduledTask/btnregister.vue";
import UserMenu from "./components/UserMenu.vue";
import StatusMenu from "./components/StatusMenu.vue";
import MessagePreviewDialog from "../UserMessages/MessagePreviewDialog.vue";
import BreakMenu from "@/components/Breaks/BreakMenu.vue";

export default {
  name: "Toolbar",

  components: {
    UserMenu,
    SmsSend,
    AgentDialerDialog,
    TypificationForm,
    newScheduledTask,
    StatusMenu,
    MessagePreviewDialog,
    BreakMenu,
  },

  data: () => ({
    title: null,
    responsive: false,
    toolbarIcons: true,
    search: "",
    userData: {},
    isOpenEventForm: false,
    // Messages
    isOpenMessagesDialog: false,
    isOpenAgentDialerDialog: false,
    isOpenTypification: false,
    messageSelectedId: null,
    messageList: [],
    messageDataOptions: {},
    messagesUnreadCounter: 0,
    messagePage: 1,
    messageTotalPages: 1,
    totalMessages: 0,
    menuItems: [
      // { title: "Pausas", icon: "mdi-coffee", action: "Perfil" },
      { title: "Perfil", icon: "mdi-account-circle", path: "Perfil" },
    ],
    isLoadingConnect: false,
    getExtensionDialog: false,
    isOpenSmsDialog: false,
    typificationData: { temporaryTableId: null, queueNumberSelected: null },
    dataFromCall: {},
  }),

  created() {
    this.GetProfileInfo();

    let theme = localStorage.getItem("theme");
    let isTrueSet = theme == "true";
    this.$vuetify.theme.dark = isTrueSet;
    this.getMessages();
  },

  mounted() {
    this.GetProfileInfo();

    this.userData = JSON.parse(localStorage.getItem("user"));

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.getBreks();
    if (this.ProfileInfo.auto_connection) this.verifyExtension();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    notify() {
      return this.$store.getters["user/GET_NOTIFY"];
    },

    smsDialog() {
      return this.$store.getters["user/GET_ISOPENSMSDIALOG"];
    },

    Breaks() {
      return this.$store.getters["breaks/GET_ALL_BREAKS"];
    },

    PageTitle() {
      return this.$store.getters["layout/TITLE_VALUE"];
    },

    MessagesUnreadCounter() {
      return this.messageList.reduce((acc, el) => (el.for[0].view === 0 ? acc + 1 : acc), 0) || 0;
    },

    isConnectedToSIP() {
      return this.$store.getters["dialer/GET_IS_CONNECTED"];
    },

    showAgentCall() {
      const isCallsEnabled = this.ProfileInfo.web_rtc ? (this.isConnectedToSIP ? true : false) : true;
      return this.userData.role_id === 3 && isCallsEnabled;
    },

    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },

    AutoAnswerCalls() {
      return !!this.ProfileInfo.web_rtc?.auto_answer;
    },

    ...mapState({
      // Breaks: state => state.breaks.allBreaks,
      extensionVariableValue: (state) => state.passport.user.variable,
      connectValue: (state) => state.passport.user.connect,
      messageQueue: (state) => state.passport.messageQueue,
    }),
  },

  watch: {
    $route(val) {
      this.title = val.name;
    },
    messagePage() {
      this.getMessages();
    },
    DTMF() {
      this.sipSendDTMF();
    },
  },

  filters: {
    hour(value) {
      return moment(value)
        .locale("es")
        .format("LT");
    },
  },

  methods: {
    closeFormDialog() {
      this.isOpenEventForm = false;
    },

    async GetProfileInfo() {
      try {
        // const enviar = { id: this.$route.params.id };
        await this.$store.dispatch("passport/ACTIVE_USER");
      } catch (error) {
        console.error("error al obtener perfil", error);
      }
    },

    drawer() {
      let value = this.$store.getters["layout/DRAWER_VALUE"];
      value = !value;
      this.$store.commit("layout/SET_DRAWER", value);
    },

    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },

    async getBreks() {
      await this.$store.dispatch("breaks/SHOW_BREAKS_AGENTS");

      // if (this.ProfileInfo.auto_connection === 1) {
      //   console.info("Hello world");
      // }
    },

    async agentBreak(item) {
      try {
        const confirmRequest = await this.$swalconfirm(item.name, "¿Desea comenzar esta pausa?");
        if (confirmRequest.isConfirmed) {
          this.$store.commit("layout/SET_OVERLAY", {
            value: true,
            title: "Pausa en proceso",
          });
          await this.handleStartBreak(item.id);
        }
      } catch (error) {
        this.$snotify.error("No se pudo iniciar la pausa.", "¡Error!");
        console.error("PAUSA", error);
      }
    },

    async handleStartBreak(breakId) {
      if (this.ProfileInfo.connect) await await this.$store.dispatch("passport/DISCONNECT_QUEUES");
      if (this.hasRTC)
        setTimeout(() => {
          this.$store.dispatch("dialer/SET_IS_CONNECTED", true);
        }, 5000);

      setTimeout(async () => {
        await this.$store.dispatch("breaks/USE_BREAK", {
          pause_id: breakId,
        });
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }, 5000);
    },

    verifyExtension() {
      if (this.ProfileInfo.connect === 0 && this.ProfileInfo.extension === null) {
        this.getExtensionDialog = true;
      }
      // auxiliar, luego borrar al corregir datos en backend
      else if (this.ProfileInfo.connect === 0 && this.ProfileInfo.extension == 0) {
        this.getExtensionDialog = true;

        return;
      } else {
        this.connect(this.ProfileInfo.extension);
      }
    },

    async connect(extension) {
      this.isLoadingConnect = true;

      try {
        const res = await this.$store.dispatch("passport/RESET_CONNECTION_AGENT", extension);

        if (res.status === 200) {
          for (const client of res.data) {
            switch (client.codigo) {
              case "Added":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;

              case "Command":
                this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");

                break;

              case "Removed":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;
            }
          }
          this.GetProfileInfo();
        }
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Error al conectar a planta.", "Error 500");
      } finally {
        this.isLoadingConnect = false;
      }
    },

    async getMessages() {
      try {
        // eslint-disable-next-line no-unused-vars
        let counter = null;
        const messages = await PbxHttpClient.get("/message_user", {
          params: {
            page: this.messagePage,
          },
        });
        // console.log("messages:", messages);
        this.messageList = messages.data.data;

        this.messageTotalPages = messages.data.last_page;
        this.messagesUnreadCounter = messages.data.data.reduce((acc, el) => (el.for[0].view === 0 ? acc + 1 : acc), 0);
        if (messages.data.data.length > 0) counter = await PbxHttpClient.get("/count_messages");
        // console.log("counter", counter);
        // this.messagesUnreadCounter = counter.data
      } catch (err) {
        console.log("error getting messages", err);
      }
    },

    viewMessage(id) {
      this.messageSelectedId = id;
      this.isOpenMessagesDialog = true;
      this.messageList = this.messageList.map((msg) =>
        msg.id === id
          ? {
              ...msg,
              for: [{ ...msg.for[0], view: 1 }],
            }
          : msg,
      );
    },
    closeMessageDialog() {
      this.messageSelectedId = null;
      this.isOpenMessagesDialog = false;
    },
    openDialerDialog() {
      this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    },
    toggleIsConnectedToSip() {
      this.$store.dispatch("dialer/TOGGLE_IS_CONNECTED");
    },
    async getTypification(payload) {
      try {
        // debugger;
        // console.log("payload", payload);
        await new Promise((res) =>
          setTimeout(() => {
            res();
          }, 2000),
        );
        const { data } = await PbxHttpClient.get(`/typing/typing_call/get`, {
          params: {
            extension: this.hasRTC ? undefined : this.extensionVariableValue,
          },
        });
        const item = data.data.find((call) => call.call_number === payload.call_number);
        this.typificationData = {
          temporaryTableId: item.id,
          queueNumberSelected: payload.queue,
        };
        this.isOpenTypification = true;
      } catch (error) {
        console.log("error getting typification", error);
        this.$snotify.error("Hubo un error buscando la tipificacion.", "¡Error!");
      }
    },

    ...mapActions("user", ["OPENSMSDIALOG", "CLOSESMSDIALOG"]),
  },
};
</script>
<style></style>
